import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const useDismissOrderCancellationBanner = () => {
  return useMutation(mutations.dismissOrderCancellationBanner, {
    onSuccess: () => {
      void hubQueryClient.invalidateQueries('dismissedOrderCancellationBanners')
    }
  })
}
